// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
// Service
import { BroadcastService, ModalService, ToasterType } from '@cv-invision/core';
import { OverviewSubHeaderService } from '../service/overview-sub-header.service';
import { QualityDocumentService } from '../../../service/document-quality.service';
// State
import { Store } from '@ngxs/store';
import { QualityState } from '../../../state/quality.state';
//Utils
import { Observable, Subject, takeUntil } from 'rxjs';
// Models
import { OrderDetailModel } from '../../../state/model/order-detail.model';
import { ORDER_STATE } from '../../../model/quality.constant';

@Component({
	selector: 'cv-not-reviewed',
	templateUrl: 'not-reviewed.component.html'
})
export class NotReviewedComponent implements OnInit, OnDestroy {
	get lockedBy(): any {
		return this.overviewSubheaderService.orderLocked;
	}

	orderDetail$: Observable<OrderDetailModel> = this.store.select(QualityState.getOrderDetail);
	private atComponentDestroy = new Subject();
	orderDetails: OrderDetailModel;
	disableButton: boolean = false;

	constructor(
		private overviewSubheaderService: OverviewSubHeaderService,
		private broadcastService: BroadcastService,
		private modalService: ModalService,
		private qualityDocumentService: QualityDocumentService,
		private store: Store
	) {}

	ngOnInit(): void {
		this.orderDetail$.pipe(takeUntil(this.atComponentDestroy)).subscribe((orderDetail: OrderDetailModel) => {
			const { stateEnum } = orderDetail;
			this.orderDetails = structuredClone(orderDetail);
			// Check if the order is locked by de current user and if the state of the order is not under Approved or Not reviewed
			if (this.lockedBy.byTheUser) {
				this.disableButton =
					stateEnum === ORDER_STATE.NOTREVIEWED || stateEnum === ORDER_STATE.APPROVED ? true : false;
			} else {
				this.disableButton = true;
			}
		});
	}

	/**
	 * Function that triggers a confirm model to change the order status
	 */
	loadConfirm(): void {
		this.modalService
			.customConfirm(
				'Change Status',
				`The order status wil be switched to "Not Reviewed"`,
				'',
				'Confirm',
				'cv-btn-primary'
			)
			.subscribe(async (result) => {
				if (result.confirm === 'confirm') {
					this.changeOrderStatus();
				}
			});
	}

	/**
	 * Function that calls the PUT service to change the order status to not reviewed
	 */
	changeOrderStatus(): void {
		this.qualityDocumentService.markOrderNotReviewed(this.orderDetails.id).subscribe({
			next: () => {
				this.broadcastService.broadcast({
					name: ToasterType.SUCCESS,
					event: {
						message: 'Order status changed succesfully.'
					}
				});

				this.overviewSubheaderService.subheaderEvents.next({ name: 'RETURN_HOME' });
			},
			error: (err) => {
				console.error(err);
			}
		});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.unsubscribe();
	}
}
